import { areArraysEqual, areValuesEqual } from '.';
import { Field, FieldData, ReviewDataProps } from './types';

export const checkIfNeedsReview = (
  field: Field,
  valueToCompare: FieldData,
): ReviewDataProps => {
  const { value: currentFieldValue } = field.currentRecordData || {};
  const { value: previousFieldValue } = valueToCompare || {};
  let valuesArrays: any[] = [];
  let optionsToShow: any[] = [];
  let hasConflictData = !!field.reviewProps?.hasConflictData;
  const isCurrentValueArray = Array.isArray(currentFieldValue);
  const isPreviousValueArray = Array.isArray(previousFieldValue);
  if (!hasConflictData) {
    const bothValuesAreArray = isCurrentValueArray && isPreviousValueArray;
    const oneValueIsArray = isCurrentValueArray || isPreviousValueArray;
    if (bothValuesAreArray) {
      hasConflictData =
        !!currentFieldValue.length &&
        !!previousFieldValue.length &&
        !areArraysEqual(currentFieldValue, previousFieldValue, true);
    } else if (oneValueIsArray) {
      hasConflictData = !areArraysEqual(
        isCurrentValueArray ? currentFieldValue : [currentFieldValue],
        isPreviousValueArray ? previousFieldValue : [previousFieldValue],
      );
    } else {
      hasConflictData = !areValuesEqual(currentFieldValue, previousFieldValue);
    }
  }

  const arrayValue =
    (isPreviousValueArray &&
      previousFieldValue.length &&
      previousFieldValue.sort().join(',').trim().toLowerCase()) ||
    ('string' === typeof previousFieldValue &&
      previousFieldValue.trim().toLowerCase()) ||
    previousFieldValue;
  const shouldShowValue = !(field.reviewProps?.valuesArrays || []).includes(
    arrayValue,
  );
  valuesArrays = [
    ...(field.reviewProps?.valuesArrays || []),
    ...(shouldShowValue ? [arrayValue] : []),
  ];
  optionsToShow = [
    ...(field.reviewProps?.optionsToShow || []),
    ...(shouldShowValue ? [valueToCompare] : []),
  ];

  return {
    hasConflictData,
    valuesArrays,
    optionsToShow,
  };
};
